
import React, { useEffect, useState } from "react";
import CardPlayer from "./CardPlayer";
import { CONFIG } from "../config";

export default function DeckLoader({ deckName }) {
  const [cards, setCards] = useState([]);

  useEffect(() => {
    const loadDeck = async () => {
      const res = await fetch(`/decks/${deckName}.json`);
      const baseDeck = await res.json();

      const saved = localStorage.getItem(`deckProgress_${deckName}`);
      let enriched = null;

      if (saved) {
        const parsed = JSON.parse(saved);
        if (parsed.length === baseDeck.length) {
          enriched = parsed;
        }
      }

      if (!enriched) {
        enriched = baseDeck.map((c, i) => ({
          ...c,
          id: i,
          repetitions: 0,
          lastSeen: 0,
          nextReview: 0,
          interval: 1,
          ease: 2.5,
          unlocked: i < CONFIG.initialUnlockedCount
        }));
        localStorage.setItem(`deckProgress_${deckName}`, JSON.stringify(enriched));
      }

      setCards(enriched);
    };

    loadDeck();
  }, [deckName]);

  if (cards.length === 0) return <div>Loading...</div>;

  return <CardPlayer cards={cards} setCards={setCards} deckName={deckName} />;
}
